module.exports = __webpack_public_path__ + "images/emoji-partying-face.png";